/**
 * Creates instances of Error, and can optionally wrap other errors.
 * @constructor Error OttError
 * @param {string} message - A human-readable error message.
 * @param {Object} options - Other options that aren't part of ECMAScript's Error class.
 * @param {Error|Object} options.cause - An error object that you want to wrap.
 * @param {string} options.code - An error code, usually generated by another library or API.
 */
export default class OttError extends Error {
    cause;
    code;
    constructor(message, { cause = null, code = null } = {}) {
        super(message);
        this.name = 'OttError';
        this.cause = cause;
        this.code = code;
        // overrides the setting of the message because some dodgy code is expecting it to be able to be an object rather than a string
        this.message = message;
    }
}
//# sourceMappingURL=ott-error.js.map